import { render } from "./GridTargetPeUser.vue?vue&type=template&id=5804c955&scoped=true&ts=true"
import script from "./GridTargetPeUser.vue?vue&type=script&lang=ts"
export * from "./GridTargetPeUser.vue?vue&type=script&lang=ts"

import "./GridTargetPeUser.vue?vue&type=style&index=0&id=5804c955&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5804c955"]])

export default __exports__